import React from "react";
import { useCompactListLayout } from "@/utils/hooks/useCompactListLayout";
import { SHARED_ACCESS } from "@/utils/constants/appConstants/SharedAcessConstant";
import { DateTimeFormatterComp } from "@/components/cards/DateTimeFormatterComp";
import { MobileDateField, MobileLabelValue } from "@/components/cards/MobileDateField";
import { concatenateName } from "@/utils/functions/helperFunctions";

interface SharedAccessProps {
    data?: any[] | null;
    isDeleteAccountDelegationAllowed?: boolean;
    handleRemoveAccess?: any;
    title?: string;
}

const SharedAccessTable: React.FC<SharedAccessProps> = (props) => {
    const isCompactLayout = useCompactListLayout();
    return isCompactLayout ? (
        <>
            <div className="envelope_table">
                {props.data!.map((row) => (
                    <div className="envelope_tr">
                        <div className="env_meta_data">
                            <div className="info">
                                <div
                                    className="text-dark name d-md-none bold-Text"
                                    style={{
                                        marginTop: 4,
                                        overflow: "hidden",
                                        whiteSpace: "nowrap",
                                        textOverflow: "ellipsis",
                                        maxWidth: "100%",
                                    }}
                                >
                                    {concatenateName(row.user.first_name, row.user.last_name)}
                                </div>
                                <div className="version my-2">
                                    {/* <span className="fw-bold">{SHARED_ACCESS.EMAIL}</span> */}
                                    <span>{row.user.email_address}</span>
                                </div>
                                <MobileDateField
                                    label={`${SHARED_ACCESS.START_DATE}: `}
                                    value={row.delegateUser ? row.delegateUser.start_at : row.start_at}
                                />
                                <MobileDateField
                                    label={`${SHARED_ACCESS.END_DATE}: `}
                                    value={row.delegateUser ? row.delegateUser.end_at : row.end_at}
                                />
                                <MobileLabelValue
                                    label={`${SHARED_ACCESS.PERMISSION}: `}
                                    value={row.delegateUser ? row.delegateUser.permissions.name : row.permissions.name}
                                    valueClassName="text-capitalize"
                                />
                                {props.isDeleteAccountDelegationAllowed && (
                                    <div className="version">
                                        <button className="btn btn-primary" onClick={() => props.handleRemoveAccess?.(row.id)}>
                                            {SHARED_ACCESS.REMOVE}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    ) : (
        <div>
            <table className="nk-tb-list nk-tb-ulist table-weight" style={{ tableLayout: "fixed", width: "100%" }}>
                <thead>
                    <tr className="nk-tb-item nk-tb-head">
                        <th className="nk-tb-col w-20">
                            <span>{SHARED_ACCESS.NAME}</span>
                        </th>
                        <th className="nk-tb-col w-30">
                            <span>{SHARED_ACCESS.EMAIL}</span>
                        </th>
                        <th className="nk-tb-col tb-col-mb">
                            <span>{SHARED_ACCESS.START_DATE}</span>
                        </th>
                        <th className="nk-tb-col tb-col-mb">
                            <span>{SHARED_ACCESS.END_DATE}</span>
                        </th>
                        <th className="nk-tb-col tb-col-mb">
                            <span>{SHARED_ACCESS.PERMISSION}</span>
                        </th>
                        {props.isDeleteAccountDelegationAllowed && <th className="nk-tb-col tb-col-mb"></th>}
                    </tr>
                </thead>
                <tbody className="tb-odr-body">
                    {props.data!.map((row) => (
                        <tr className="nk-tb-item">
                            <td className="nk-tb-col text-dark">{concatenateName(row.user.first_name, row.user.last_name)}</td>
                            <td className="nk-tb-col text-dark">{row.user.email_address}</td>
                            <td className="nk-tb-col tb-col-mb">
                                <DateTimeFormatterComp>{row.delegateUser ? row.delegateUser.start_at : row.start_at}</DateTimeFormatterComp>
                            </td>
                            <td className="nk-tb-col tb-col-mb">
                                <DateTimeFormatterComp>{row.delegateUser ? row.delegateUser.end_at : row.end_at}</DateTimeFormatterComp>
                            </td>
                            <td className="nk-tb-col tb-col-mb text-dark text-capitalize">
                                {row.delegateUser ? row.delegateUser?.permissions?.name : row.permissions?.name}
                                {/* <DateTimeFormatterComp>{row.end_date}</DateTimeFormatterComp> */}
                            </td>
                            {props.isDeleteAccountDelegationAllowed && (
                                <td className="nk-tb-col tb-col-mb">
                                    <button className="btn btn-primary" onClick={() => props.handleRemoveAccess?.(row.id)}>
                                        {SHARED_ACCESS.REMOVE}
                                    </button>
                                </td>
                            )}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default SharedAccessTable;
